
$(document).ready(function () {
  const menuBtn = $('#menuToggle');
  if (menuBtn) {
    menuBtn.click(() => {
      console.log("menu clicked");
      menuBtn.text((i, oldText) => {
        return oldText === 'MENU' ? 'CLOSE' : 'MENU';
      })
      $('.navbar-overlay').toggleClass('active');
    })
  }

  const menuMobileToggle = $('.nav-toggle-mobile');

  if (menuMobileToggle) {
    menuMobileToggle.on('click', function () {
      $('.navbar-mobile').toggleClass('active');
    })
  }

  const closeBtn = $('.close_x');
  if (closeBtn) {
    closeBtn.click(() => {
      $('.fixedmessagewrapper').css('display', 'none');
    })
  }

  if (window.location.href.includes('cart')) {
    $('.fixedmessagewrapper').css('display', 'none');
  }

  // number input custom

  $('.minus, .plus').on('click', function (e) {
    if (!window.location.href.includes("neil-lane")) {
      const isNegative = $(e.target).closest('.minus').is('.minus');
      const input = $(e.target).closest('.custom-button-group').find('input');
      if (input.is('input')) {
          input[0][isNegative ? 'stepDown' : 'stepUp']()
      }  
    }
  })

  // slider
  let slideIndex = 1;

  const showSlides = (index) => {
    const slides = document.getElementsByClassName('slider-item');
    if (slides.length <= 0) return; 
    if (index > slides.length) slideIndex = 1;
    if (index < 1) slideIndex = slides.length
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";  
    }

    slides[slideIndex-1].style.display = "flex";  
  }

  const prevButton = document.querySelectorAll('.prev-button');
  const nextButton = document.querySelectorAll('.next-button');

  if (prevButton && nextButton) {
    prevButton.forEach(button => {
      button.addEventListener('click', () => {
        showSlides(slideIndex -= 1);
      })
    })

    nextButton.forEach(button => {
      button.addEventListener('click', () => {
        showSlides(slideIndex += 1);
      })
    })
  }

  showSlides(slideIndex);
  // end slider


});


